export const APOLLO_DOCTOR_TYPES = ["APOLLO", "EXCLUSIVE_PARTNER", "FOCUSSED"];
export const SMALL_DOCTOR_TAG_URL = "https://images.apollo247.in/images/doctor-profile/badge.svg";
